/* eslint-disable @next/next/no-img-element */
import PencilIcon from "../../../icons/PencilIcon";
import { Button } from "../../../shadcn/components/ui/button";
import { useRouter } from "next/router";
import { getWatermarkedImgixUrl } from "services";

interface CardData {
  details?: { [key: string]: string };
  title?: string;
  propertyImage?: any;
  uuid: any;
}

export const PYPDetailsCard = ({
  details,
  title,
  uuid,
  propertyImage,
}: CardData) => {
  const router = useRouter();
  const handleClick = () => {
    router.push(`/post-your-property/${uuid}`);
  };

  function formatString(input: string): string {
    return input
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  console.log("img", propertyImage);

  return (
    <>
      <div className="w-full p-8 bg-brand-lightPink mt-8 lg:flex">
        <img
          src={
            propertyImage?.id
              ? getWatermarkedImgixUrl(
                  `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${propertyImage?.id}`,
                )
              : "../../PYPSuccess1.png"
          }
          className="clip-path-bottomRightFooterMobile lg:w-fit w-full lg:max-w-[403px]"
          alt=""
        />

        <div className="w-full mt-10 lg:mt-0 lg:ml-[60px]">
          {" "}
          <div className="w-full justify-between flex">
            <p className="font-openSans capitalize font-semibold text-mobile-subheading lg:text-web-h3 leading-6 lg:leading-[38px] text-brand-bgBlack lg:ml-4">
              {title}
            </p>
            <Button
              variant={"custom"}
              size={"custom"}
              className="hover:cursor-pointer underline "
              onClick={handleClick}
            >
              <PencilIcon className=" " />
              <p className="ml-2 font-openSans font-semibold text-mobile-body-md lg:text-[20px] leading-5 lg:leading-7">
                Edit
              </p>
            </Button>
          </div>{" "}
          <div className="mt-8">
            <ul className="grid grid-cols-3 gap-y-8 w-full">
              {details &&
                Object.entries(details).map(([key, value]) => (
                  <li key={key} className={`${value ? "" : "hidden"}`}>
                    <p className="font-openSans font-semibold text-web-body-md leading-5 text-brand-bgBlack">
                      {formatString(key)}:{" "}
                    </p>
                    <p className="font-openSans capitalize font-normal text-web-body-md leading-5 text-brand-textGrey">
                      {value}
                    </p>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default PYPDetailsCard;
